module.exports = __webpack_public_path__ + "img/armory.5f73c276.svg";